import { render, staticRenderFns } from "./CompanyCourts.vue?vue&type=template&id=4163eecd&scoped=true"
import script from "./CompanyCourts.vue?vue&type=script&lang=js"
export * from "./CompanyCourts.vue?vue&type=script&lang=js"
import style0 from "./CompanyCourts.vue?vue&type=style&index=0&id=4163eecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4163eecd",
  null
  
)

export default component.exports